import React from "react";

import isIntuit from "Intuit/isIntuit";
import Spinner from "Intuit/Spinner";
import { isTrowserRollout } from "Intuit/TrowserUtils";

import BodyText from "Common/BodyText";
import { CardSection } from "Common/Card";
import Icon from "Common/Icon";

import type { StyleProps } from "Utils/styleProps";

type Props = {
  loadingText?: string;
} & StyleProps;

const BasicLoading = ({ loadingText, ...rest }: Props) => {
  // Function to render text with newlines correctly
  const renderTextWithNewlines = (text: string) => {
    const lines = text.split("\\n");
    return lines
      .map((line, index) => [
        index > 0 && <br key={`br-${index}`} />, // Add a <br> before each line except the first one
        line,
      ])
      .flat();
  };
  return (
    <CardSection {...rest}>
      <div className="text-center">
        {isIntuit() && isTrowserRollout() ? <Spinner mx="auto" my={5} /> : <Icon icon="spinner" spin="pulse" size="5x" mx="auto" py={5} />}

        <BodyText size="large" agent pb={5}>
          {loadingText ? renderTextWithNewlines(loadingText) : "Loading\u2026"}
        </BodyText>
      </div>
    </CardSection>
  );
};

export default BasicLoading;
